'use client'

import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import {usePathname} from "next/navigation";

const SELF_HEAL_TIMEOUT_MS = 5000;
const SELF_HEAL_LIMIT_KEY = '__page_loader_self_heal_count';
const SELF_HEAL_LIMIT = 1;

export default function Loading({asReq=false}) {
    const pathname = usePathname();

    useEffect(() => {
        if(!pathname?.includes('/funding')||asReq)return;
        const timer = window.setTimeout(() => {
            const loaderStillVisible = document.body?.querySelector('.CA___41___');
            if (!loaderStillVisible) {
                return;
            }

            const reloadCount = Number(sessionStorage.getItem(SELF_HEAL_LIMIT_KEY) ?? '0');
            if (reloadCount >= SELF_HEAL_LIMIT) {
                window.setTimeout(()=>{ //Reset for issue if happened again
                    sessionStorage.setItem(SELF_HEAL_LIMIT_KEY, '0');
                },1000)
                console.warn('[PAGE_LOADER] self-heal skipped (limit reached)', {
                    pathname: window.location.pathname,
                    reloadCount,
                });
                return;
            }

            sessionStorage.setItem(SELF_HEAL_LIMIT_KEY, String(reloadCount + 1));
            console.warn('[PAGE_LOADER] self-heal triggered (reload)', {
                pathname: window.location.pathname,
                reloadCount: reloadCount + 1,
            });
            window.location.reload();
        }, SELF_HEAL_TIMEOUT_MS);

        return () => {
            window.clearTimeout(timer);
        };
    }, []);

    return (
        <div className="flex h-full items-center justify-center w-full CA___41___">
            <CircularProgress
                size={50}
                sx={{
                    color: 'var(--color-primary)'
                }}
            />
        </div>
    );
};
